import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { AfterViewInit } from '@angular/core';
@Component({
  selector: 'app-addannualleave',
  templateUrl: './addannualleave.component.html',
  styleUrls: ['./addannualleave.component.css']
})
export class AddannualleaveComponent implements OnInit,AfterViewInit {
  @ViewChild('approvebar', { static: false }) approvebar;
  @ViewChild('attachmentbar', { static: false }) attachmentbar;


  formname: string = "ANNUALLEAVE";


  //Display
  formmode: string = "Add";
  rtnform: string = "";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  isshowapproval: boolean = false;

  isapprove: boolean = false;
  isreject: boolean = false;



  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  annualleaveColl: any = [];
  annualleaveid: number = 0

  annualleaveBO: any = {}

  annualleavetypeColl: any = [];
  empColl: any = [];

  annualleaveform = new FormGroup({
    annualleaveid: new FormControl(0),
    empid: new FormControl(null, Validators.required),
    leavetypeid: new FormControl(null, Validators.required),
    transdt: new FormControl(null, Validators.required),
    startdt: new FormControl(null, Validators.required),
    enddt: new FormControl(null, Validators.required),
    expectreturndt: new FormControl(null),
    actualreturndt: new FormControl(null),
    descr: new FormControl(''),
    inactive: new FormControl(false),
  });

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.annualleaveid = params.id
      }

      if (params.rtnform !== undefined) {
        this.rtnform = params.rtnform
      }
    });

    this.fnServiceChanges();
    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.annualleaveform.reset();
      this.fnInitializeFormGroup();

      if (this.annualleaveid > 0) {
        this.fngetAnnualleave();
      }
      this.fngetAnnualleaveType();
      this.fngetEmployee();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.annualleaveid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }
  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }
  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.annualleaveform.setValue({
      annualleaveid: 0,
      empid: null,
      leavetypeid: null,
      expectreturndt: null,
      actualreturndt: null,
      startdt: new Date(),
      transdt: new Date(),
      descr: '',
      enddt: null,
      inactive: false
    })
  }

  fngetAnnualleaveType() {
    var data = {
      'leavetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getLeaveType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.annualleavetypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetEmployee() {
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.empColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetAnnualleave() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'annualleaveid': this.annualleaveid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getAnnualLeave(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.annualleaveColl = res.json().result;
            var editdata = this.annualleaveColl[0];
            this.annualleaveBO = editdata;
            this.fnEditMode(editdata);
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.annualleaveform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'annualleaveid': this.annualleaveid,
          'actualreturndt': this.fnFormatDatetime(this.annualleaveform.get('actualreturndt').value),
          'expectreturndt': this.fnFormatDatetime(this.annualleaveform.get('expectreturndt').value),
          'startdt': this.fnFormatDatetime(this.annualleaveform.get('startdt').value),
          'enddt': this.fnFormatDatetime(this.annualleaveform.get('enddt').value),
          'transdt': this.fnFormatDatetime(this.annualleaveform.get('transdt').value),
          'empid': this.annualleaveform.get('empid').value,
          'leavetypeid': this.annualleaveform.get('leavetypeid').value,
          'descr': this.annualleaveform.get('descr').value,
          'inactive': this.annualleaveform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }



        if (this.annualleaveform.get('annualleaveid').value > 0) {
          //Update 
          this.fnSetAnnualleave(data);
        }
        else {
          //Insert 
          this.fnInsertAnnualleave(data);
        }


      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertAnnualleave(data) {

    this.appService.fnInsertAnnualLeave(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new annualleave has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));

            var _result = res.json().result;

            if (_result.length > 0) {
              var resdata = _result[0];
              if (resdata.length > 0) {
                this.fnAttachmentSave(resdata[0].annualleaveid);
              }
            }
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetAnnualleave(data) {

    this.appService.fnSetAnnualLeave(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The annualleave has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.annualleaveid, this.fngetDescriptionRefno(data));

            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }
  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }
  //Close
  fnCloseForm() {
    try {
      if (this.rtnform !== '') {
        this.router.navigate(['/' + this.rtnform]);
      }
      else {
        this.router.navigate(['/Annualleave']);
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {

    deptBO.startdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.startdt));
    deptBO.enddt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.enddt));
    deptBO.expectreturndt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.expectreturndt));
    deptBO.actualreturndt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.actualreturndt));
    deptBO.transdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));

    this.annualleaveform.setValue({
      annualleaveid: deptBO.annualleaveid,
      empid: deptBO.empid,
      leavetypeid: deptBO.leavetypeid,
      expectreturndt: deptBO.expectreturndt,
      actualreturndt: deptBO.actualreturndt,
      startdt: deptBO.startdt,
      transdt: deptBO.transdt,
      descr: deptBO.descr,
      enddt: deptBO.enddt,
      inactive: deptBO.inactive
    });

    this.formmode = "";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    this.fnVisibilityApproveStatus();

  }


  //Approvals
  fnApproveBtnClick(type) {


    this.approvebar.formtype = type;
    this.approvebar.fnInitializeFormGroup();
    this.approvebar.fnGetApproveForms();

    this.isshowapproval = !this.isshowapproval

  }

  fnCloseApproveBtnClick(data) {
    this.isshowapproval = !this.isshowapproval

    if (data === 'DONE') {
      this.fngetAnnualleave();
    }

  }

  fnVisibilityApproveStatus() {

    this.isapprove = false;
    this.isreject = false;

    if (this.annualleaveBO.approvedstatus !== '') {
      if (this.annualleaveBO.approvedstatus === 'Approve') {
        this.isreject = true;
      }
      else if (this.annualleaveBO.approvedstatus === 'Reject') {
        this.isapprove = true;
      }
    }
    else {
      this.isapprove = true;
      this.isreject = true;
    }

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }
  fnAttachmentBtnClick() {
    this.attachmentbar.formtype = this.formname;
    this.attachmentbar.trxid = this.annualleaveid;

    if (this.annualleaveid > 0) {
      this.attachmentbar.formmode = "EDIT";
    }
    else {
      this.attachmentbar.formmode = "ADD";
    }

    this.attachmentbar.fnGetAttachment();

    this.isshowattachment = !this.isshowattachment

  }


  fnAttachmentSave(tid) {

    if (this.attachmentcount > 0) {

      this.attachmentbar.formtype = this.formname;
      this.attachmentbar.trxid = tid;
      this.attachmentbar.formmode = "ADD";

      this.attachmentbar.fnSaveAttachmentByAddMode();
    }
    else {
      this.fnCloseForm();
    }

  }

  fnSetAttachmentCount(data) {

    this.attachmentcount = data;
  }

  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}
